export default {
  get (key) {
    const match = document.cookie.match(new RegExp(key + '=([^;]+)'));
    return match ? match[1] : '';
  },
  set (key, value, expires = 30 * 24 * 3600 * 1000) {
    const date = new Date();
    date.setTime(date.getTime() + expires);
    document.cookie = key + '=' + value + ';expires=' + date.toGMTString();
  }
};



// WEBPACK FOOTER //
// ./src/utils/tools/_cookie.js